import gql from 'graphql-tag'

export const fetchNewsCategory = news_category_id => {
	return {
		query: gql`
			query ($news_category_id: bigint!) {
				news_category: news_categories_by_pk(id: $news_category_id) {
					category_name
					country_id
					style
					image {
						file_name
						mime
						url
						id
					}
				}
			}
		`,
		variables: { news_category_id }
	}
}
